import { tickets } from "../store/tickets";
import {
  paletteOpen,
  quickAddOpen,
  selectedId,
  setPaletteOpen,
  setQuickAddOpen,
  setSelectedId,
} from "../store/ui";

// G-prefix sequence (G then L/T) lives outside the handler so a brief
// 800ms window is enough to chain. Spec rejects any keyboard-shortcut lib;
// this is the whole implementation.
let gPressed = false;
let gTimeout: number | undefined;

function isTextInputFocused(): boolean {
  const el = document.activeElement;
  if (!el) return false;
  const tag = el.tagName;
  if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return true;
  return (el as HTMLElement).isContentEditable === true;
}

function step(direction: 1 | -1): void {
  const list = tickets();
  if (list.length === 0) return;
  const cur = selectedId();
  const idx = cur === null ? -1 : list.findIndex((t) => t.id === cur);
  const next =
    direction === 1
      ? Math.min(list.length - 1, idx + 1)
      : Math.max(0, idx - 1);
  setSelectedId(list[next].id);
}

export function installShortcuts(navigate: (path: string) => void): () => void {
  const handler = (e: KeyboardEvent) => {
    // ⌘K / Ctrl+K opens palette even when an input is focused — palette is
    // a global escape hatch.
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
      e.preventDefault();
      setPaletteOpen((open) => !open);
      return;
    }

    // Palette and quick-add modal have their own key handling; don't
    // double-process while either is open.
    if (paletteOpen() || quickAddOpen()) return;
    // Don't capture single-letter shortcuts while the user is typing somewhere.
    if (isTextInputFocused()) return;

    if (e.key === "g" || e.key === "G") {
      gPressed = true;
      if (gTimeout !== undefined) clearTimeout(gTimeout);
      gTimeout = window.setTimeout(() => {
        gPressed = false;
      }, 800);
      return;
    }

    if (gPressed) {
      gPressed = false;
      if (gTimeout !== undefined) clearTimeout(gTimeout);
      const k = e.key.toLowerCase();
      if (k === "h") navigate("/today");
      else if (k === "l") navigate("/list");
      else if (k === "t") navigate("/tree");
      return;
    }

    if (e.key === "j" || e.key === "J") {
      e.preventDefault();
      step(1);
      return;
    }

    if (e.key === "k" || e.key === "K") {
      e.preventDefault();
      step(-1);
      return;
    }

    if (e.key === "c" || e.key === "C") {
      e.preventDefault();
      setQuickAddOpen(true);
      return;
    }

    if (e.key === "/") {
      e.preventDefault();
      setPaletteOpen(true);
    }
  };

  document.addEventListener("keydown", handler);
  return () => document.removeEventListener("keydown", handler);
}
